export const AuthRoutes = {
    Authenticated: "authenticated"
};
